import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import httpRequest from "../HttpService";
import Tracking from "./index";
import JobList from "./JobList";
import NoReferenceResults from "./NoReferenceResults";

// Single entry point for https://tracking.directx.ca/track?...
// A plain HTML GET form (on a site we do not control) targets this directly.
// TrackNumber -> detail page. TrackAccount+Reference -> search, then detail
// or a list. Neither -> the manual tracking form. If both are supplied, the
// reference wins - the existing precedence.
export default function TrackEntry() {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [view, setView] = useState("loading"); // loading | list | empty | error | form
    const [jobs, setJobs] = useState([]);

    const trackNumber = (searchParams.get("TrackNumber") || "").trim();
    const trackAccount = (searchParams.get("TrackAccount") || "").trim();
    const reference = (searchParams.get("Reference") || "").trim();

    useEffect(() => {
        if (trackAccount && reference) {
            httpRequest
                .searchByReference(trackAccount, reference)
                .then((response) => {
                    const rows = Array.isArray(response.data) ? response.data : [];
                    if (rows.length === 1) {
                        navigate(`/trackNo/${rows[0].TrackNumber}`, { replace: true });
                    } else if (rows.length > 1) {
                        setJobs(rows);
                        setView("list");
                    } else {
                        setView("empty");
                    }
                })
                .catch((err) => {
                    console.error("searchByReference failed", err);
                    setView("error");
                });
        } else if (trackNumber) {
            navigate(`/trackNo/${trackNumber}`, { replace: true });
        } else {
            setView("form");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [trackAccount, reference, trackNumber]);

    switch (view) {
        case "list":
            return <JobList jobs={jobs} reference={reference} />;
        case "empty":
            return <NoReferenceResults reference={reference} />;
        case "error":
            return <NoReferenceResults reference={reference} error />;
        case "form":
            return <Tracking type="none" />;
        default:
            return null;
    }
}
